import { FileUpload } from "primereact/fileupload";
import { Button } from "primereact/button";
import { Tag } from "primereact/tag";
import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import FileUploadService from "../api/services/FileUploadService";
import { FILE_TYPE } from "../../utilities/constants/ITMISConstansts";

const GbvHttFileUpload = (props) => {
  const [fileType, setFileType] = useState();
  const toast = useRef(null);
  const onTemplateRemove = (file, callback) => {
    callback();
  };

  const headerTemplate = (options) => {
    const { className, chooseButton } = options;

    return (
      <div
        className={className}
        style={{
          backgroundColor: "transparent",
          display: "flex",
          alignItems: "center",
        }}
      >
        {chooseButton}
      </div>
    );
  };

  const fileUploadItemTemplate = (file, fileProps) => {
    return (
      <>
        <Toast ref={toast}></Toast>
        <div className="p-d-flex p-ai-center p-flex-wrap">
          <div className="p-d-flex p-ai-center" style={{ width: "40%" }}>
            {/* <img alt={file.name} role="presentation" src={file.objectURL} width={100} /> */}
            <span className="p-d-flex p-dir-col p-text-left p-ml-3">{file.name}</span>
          </div>
          <Tag value={fileProps.formatSize} severity="" className="p-px-3 p-py-2 p-mr-1" />
          <Tag value={file.noOfPages} severity="" className="p-px-3 p-py-2" />
          <Button
            type="button"
            icon="pi pi-times"
            className="p-button-outlined p-button-rounded p-button-danger p-ml-auto"
            onClick={() => onTemplateRemove(file, fileProps.onRemove)}
          />
        </div>
      </>
    );
  };

  const fileUploader = (e) => {
    let formData = new FormData();
    formData.append("file", e.files[0]);

    if (e.files[0].type == "application/pdf") {
      var reader = new FileReader();
      reader.readAsBinaryString(e.files[0]);
      reader.onloadend = function () {
        // var count = reader.result.match(/\/Type[\s]*\/Page[^s]/g).length;
        e.files[0].noOfPages = 1;
      };
    } else {
      e.files[0].noOfPages = 1;
    }

    FileUploadService.postFile(formData).then((response) => {
      if (props.index != undefined) {
        props.handleUploadState(response.data);
      } else {
        props.handleUploadState(response.data);
      }
    });
  };

  const emptyTemplate = () => {
    return <p className="p-m-0">Drag and drop files to here to upload.</p>;
  };

  useEffect(() => {
    if (props.settings && props.settings.fileUploadType) {
      let fileTypeValue = [];
      for (const key in props.settings.fileUploadType) {
        if (FILE_TYPE[`${props.settings.fileUploadType[key]}`] != undefined) {
          fileTypeValue.push(FILE_TYPE[`${props.settings.fileUploadType[key]}`]);
        }
      }
      console.log("fileTypeValue", fileTypeValue.join());
      setFileType(fileTypeValue.join());
    } else {
    }
  }, [props.settings]);
  return (
    <>
      <FileUpload
        name="demo"
        //accept={props.fileType ? props.fileType : fileType}
        accept="image/*, application/pdf"
        itemTemplate={fileUploadItemTemplate}
        headerTemplate={headerTemplate}
        customUpload
        uploadHandler={fileUploader}
        auto
        chooseLabel="Upload a file"
       // emptyTemplate={emptyTemplate}
      // maxFileSize={
      //   props.settings && props.settings.fileUploadSize
      //     ? props.settings.fileUploadSize
      //     : "1000000000"
      // }
      />
    </>
  );
};
export default GbvHttFileUpload;
